<template lang="pug">
.content-center
  .bets-wrap
    ul.d-flex.justify-content-around
      li.flex-grow-1
        a#runningList(href="javascript:void(0);" @click="goTab(0)" :class="{ 'active' : selected == 0 }") {{ $t("ui.running") }}
      li.flex-grow-1
        a(href="javascript:void(0);" @click="goTab(1)" :class="{ 'active' : selected == 1 }") {{ $t("ui.settled") }}
      li.flex-grow-1
        a(href="javascript:void(0);" @click="goTab(2)" :class="{ 'active' : selected == 2 }") {{ $t("ui.void") }}
    .filter-running(v-if="[0, 1].includes(selected)")
      .left.dropdown(v-if="[0].includes(selected)")
        //- .bet-type-select(@click="expandFilter($event)") {{ $tc("m.BT_" + betType, 1) }} ({{ resultTotalRow }})
        .dropdown-btn(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false') {{ $tc("m.BT_" + betType, 1) }} ({{ resultTotalRow }})
        ul.dropdown-menu
          li
            a.dropdown-item(@click="setBetType('ALLBT')") {{ $tc("m.BT_ALLBT", 1) }}
          li
            a.dropdown-item(@click="setBetType('HDP')") {{ $tc("m.BT_HDP", 1) }}
          li
            a.dropdown-item(@click="setBetType('OU')") {{ $tc("m.BT_OU", 1) }}
          li
            a.dropdown-item(@click="setBetType('OE')") {{ $tc("m.BT_OE", 1) }}
          li
            a.dropdown-item(@click="setBetType('1X2HDP')") {{ $tc("m.BT_1X2HDP", 1) }}
          li
            a.dropdown-item(@click="setBetType('CS')") {{ $tc("m.BT_CS", 1) }}
          li
            a.dropdown-item(@click="setBetType('OR')") {{ $tc("m.BT_OR", 1) }}
          li
            a.dropdown-item(@click="setBetType('PARLAY')") {{ $tc("m.BT_PARLAY", 1) }}
      .left(v-else)
        .total-stake
          | {{ $t("ui.winlose") }}:
          span.amount.ml-1 {{ $numeral(totalWinlose).format("0,0.00") }}
      .right
        .total-stake
          | {{ $t("ui.total_stake") }}:
          span.amount.ml-1 {{ $numeral(totalStake).format("0,0.00") }}
  .page-panel
    .page-group#statement-0.statement-wrap
      .pagination-wrapper
        v-pagination(
          v-model="currentPage"
          :page-count="resultTotalPages"
          :classes="bootstrapPaginationClasses"
          :labels="paginationAnchorTexts"
          @input="changedPage($event)"
          v-if="resultTotalPages"
        )
      .refresh-wrapper(v-if="[0].includes(selected) && this.isPendingList")
        .refresh-count(v-if="this.counter > 0" @click="refreshList()") {{ $t("ui.auto_refresh") }} ({{ counter }})
        .refresh-count(v-else) {{ $t("ui.auto_refreshing") }}
      template(v-if="loading")
        .message.dark
          .empty.text-center.mt-2.pt-4
            .loading-wrap.mb-2
              .loading
                .block
                .block
                .block
          p.no-message.text-center.text-dark {{ $t("ui.loading") }}
      template(v-else)
        template(v-if="betList.length <= 0")
          .message.dark
            .empty.text-center.mt-3.pt-4
              i.fad.fa-exclamation-triangle
            p.no-message.text-center.text-dark {{ $t("message.no_information_available") }}
        template(v-else)
          template(v-for="match in betList")
            template(v-if="['MMK','MMO'].includes($store.getters.currencyCode)")
              template(v-if="match.bet_type == 'PARLAY'")
                betSlipParlayMMO(:index="index" :match="match" :filterMenu="filterMenu" :status="status")
              template(v-else)
                betSlipMMO(:index="index" :match="match" :filterMenu="filterMenu" :leagueList="mainLeague" :matchList="mainMatch" :status="status" :isStatement="selected == 1")
            template(v-else)
              template(v-if="match.bet_type == 'PARLAY'")
                betSlipParlay(:index="index" :match="match" :filterMenu="filterMenu" :status="status")
              template(v-else)
                betSlip(:index="index" :match="match" :filterMenu="filterMenu" :leagueList="mainLeague" :matchList="mainMatch" :status="status" :isStatement="selected == 1")
      .note-panel.text-left(v-if="selected == 1")
        span {{ $t("ui.settled_remark") }}
      .swith-market-btn
        router-link(href="javascript:void(0);" to="/statement")
          span {{ $t("ui.goto_statement") }}
          span.icon
            i.fas.fa-caret-right
      .pagination-wrapper
        v-pagination(
          v-model="currentPage"
          :page-count="resultTotalPages"
          :classes="bootstrapPaginationClasses"
          :labels="paginationAnchorTexts"
          @input="changedPage($event)"
          v-if="resultTotalPages"
        )
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import vPagination from "vue-plain-pagination";
import config from "@/config";
import errors from "@/errors";
import xhr from "@/library/_xhr-betlist.js";
import service from "@/library/_xhr-statement";
import naming from "@/library/_name";
import betSlip from "@/components/mobile/bets/betSlip";
import betSlipParlay from "@/components/mobile/bets/betSlipParlay";
import betSlipMMO from "@/components/mobile/bets/mmo/betSlip";
import betSlipParlayMMO from "@/components/mobile/bets/mmo/betSlipParlay";

export default {
  components: {
    vPagination,
    betSlip,
    betSlipParlay,
    betSlipMMO,
    betSlipParlayMMO
  },
  data() {
    return {
      loading: false,
      isPendingList: false,
      checkCounter: null,
      counter: 5,
      index: 0,
      selected: 0,
      filterMenu: "sportsbook",
      status: "running",
      mainMatch: [],
      mainLeague: [],
      betList: [],
      pendingBetList: [],
      currDate: this.$dayjs().subtract("12", "hours").format("YYYY-MM-DD", config.timeZone),
      betType: "ALLBT",
      totalWinlose: 0,
      totalStake: 0,
      feedback: {
        success: false,
        status: errors.session.invalidSession
      },
      currentPage: 1,
      currentResultPage: 1,
      resultTotalRow: 0,
      resultTotalPages: 0,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      }
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  destroyed() {
    clearInterval(this.checkCounter);
  },
  mounted() {
    this.goTab(0);
  },
  methods: {
    handleCounter() {
      if(this.counter > 0) {
        this.counter -= 1;
      } else {
        this.refreshList();
        this.counter = 5;
      }
    },
    goTab(e) {
      clearInterval(this.checkCounter);
      this.selected = e;
      this.currentPage = 1;
      this.currentResultPage = 1;
      switch (e) {
        case 0:
          this.status = "running";
          this.getBetAcceptFullList();
          break;
        case 1:
          this.status = "";
          this.getGameResult();
          break;
        case 2:
          this.status = "rejected";
          this.getBetRejectFullList();
          break;
      }
    },
    changePageList() {
      switch (this.selected) {
        case 0:
          this.status = "running";
          this.refreshList();
          break;
        case 1:
          this.status = "";
          this.getGameResult();
          break;
        case 2:
          this.status = "rejected";
          this.getBetRejectFullList();
          break;
      }
    },
    expandFilter(evt) {
      evt.stopPropagation();
      $(".bet-type-select-menu").slideToggle();
    },
    setBetType(e) {
      this.betType = e;
      this.currentPage = 1;
      this.currentResultPage = 1;
      $(".bet-type-select-menu").hide();
      this.changePageList();
    },
    refreshList() {
      clearInterval(this.checkCounter);
      if (this.betType == "ALLBT") {
        this.getBetAcceptFullList();
      } else {
        this.getBetAcceptFullListBetType();
      }
    },
    getBetAcceptFullList(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.betList = [];
        this.totalStake = 0;
        this.resultTotalRow = 0;
        this.resultTotalPages = 0;
        this.counter = 5;
        this.isPendingList = false;

        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          page_number: this.currentResultPage,
          page_size: this.getPageSize
        };
        xhr.getBetAcceptFullList(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data.length > 0) {
                this.betList = res.data;
                this.totalStake = res.data[0].total_betmember;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);

                this.isPendingList = res.data.filter(x => x.bet_status.toLowerCase() == "pending").length > 0;
                if(this.isPendingList) {
                  this.checkCounter = setInterval(this.handleCounter, 1000);
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getBetAcceptFullListBetType(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.betList = [];
        this.totalStake = 0;
        this.resultTotalRow = 0;
        this.resultTotalPages = 0;
        this.counter = 5;
        this.isPendingList = false;

        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_type: this.betType,
          page_number: this.currentResultPage,
          page_size: this.getPageSize
        };
        xhr.getBetAcceptBetTypeList(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data.length > 0) {
                this.betList = res.data;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);

                res.data.forEach(x => {
                  this.totalStake += x.bet_member;
                });

                this.isPendingList = res.data.filter(x => x.bet_status.toLowerCase() == "pending").length > 0;
                if(this.isPendingList) {
                  this.checkCounter = setInterval(this.handleCounter, 1000);
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getBetRejectFullList(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        this.betList = [];
        this.resultTotalRow = 0;
        this.resultTotalPages = 0;

        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          page_number: this.currentResultPage,
          page_size: this.getPageSize
        };
        xhr.getBetRejectFullList(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                this.betList = res.data;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getGameResult() {
      this.currDate = this.$dayjs().subtract("12", "hours").format("YYYY-MM-DD", config.timeZone);
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        start_date: this.currDate,
        end_date: this.currDate,
        category_type: "SPORTSBOOK",
        page_number: this.currentResultPage,
        page_size: this.getPageSize,
        match_id: null,
        bet_type: this.betType == "ALLBT" ? "" : this.betType
      };

      this.loading = true;
      this.betList = [];
      this.mainMatch = [];
      this.mainLeague = [];
      this.totalStake = 0;
      this.resultTotalRow = 0;
      this.resultTotalPages = 0;

      service.getGameResult(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              if (result.data["Table"].length > 0) {
                this.betList = result.data["Table"];
                if (this.filterMenu == "sportsbook") {
                  this.mainMatch = result.names["Table"];
                  this.mainLeague = result.names["Table1"];
                }
                this.totalStake = result.data["Table1"][0].bet_member;
                this.totalWinlose = result.data["Table1"][0].winlose;
                this.resultTotalRow = this.betList.length > 0 ? this.betList[0].totalrows : 0;
                if (this.resultTotalRow % this.getPageSize != 0) this.resultTotalPages = Math.ceil(parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize));
                else this.resultTotalPages = parseFloat(this.resultTotalRow) / parseFloat(this.getPageSize);
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    changedPage(pageNo) {
      this.currentResultPage = pageNo;
      this.changePageList();
    }
  }
};
</script>
